import { createPalette, usePaletteTrigger } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { SidebarButton } from '@gitbook/spine-react';

import { useContactSupport } from '../../state';
import { createDocumentationURL } from '../../utils/createDocumentationURL';

/**
 * A palette button giving access to various actions related to getting help.
 */
export function HelpButton() {
    const contactSupport = useContactSupport();

    const { triggerProps } = usePaletteTrigger({
        palette: () =>
            createPalette({
                groups: [
                    {
                        key: 'help',
                        commands: [
                            {
                                key: 'help.keyboard_shortcuts',
                                title: 'Keyboard shortcuts',
                                icon: Icon.EnterKey,
                                trigger: () => {
                                    window.open(
                                        createDocumentationURL('resources/keyboard-shortcuts'),
                                        '_blank'
                                    );
                                },
                            },
                            {
                                key: 'help.read_the_docs',
                                title: 'Documentation',
                                icon: Icon.BookOpen,
                                trigger: () => {
                                    window.open(createDocumentationURL(''), '_blank');
                                },
                            },
                            {
                                key: 'help.changelog',
                                title: 'Changelog',
                                icon: Icon.DeviceDesktop,
                                trigger: () => {
                                    window.open(createDocumentationURL('changelog'), '_blank');
                                },
                            },
                            {
                                key: 'help.community',
                                title: 'Community',
                                icon: Icon.GitHub,
                                trigger: () => {
                                    window.open(
                                        'https://github.com/GitbookIO/community/discussions',
                                        '_blank'
                                    );
                                },
                            },
                        ],
                    },
                    {
                        key: 'help_contact',
                        commands: [
                            {
                                key: 'help.suggest_feature',
                                title: 'Suggest a feature',
                                icon: Icon.Bulb,
                                trigger: () => {
                                    window.open(
                                        'https://github.com/orgs/GitbookIO/discussions/categories/feature-requests',
                                        '_blank'
                                    );
                                },
                            },
                            {
                                key: 'help.contact_support',
                                title: 'Contact us',
                                icon: Icon.Send,
                                trigger: async () => {
                                    contactSupport();
                                },
                            },
                        ],
                    },
                ],
            }),
    });

    return (
        <SidebarButton {...triggerProps} iconOnly outlined label="Help" icon={Icon.HelpCircle} />
    );
}
